import { FC, PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { LoadingContext, LoadingContextValue } from './LoadingContext';

/**
 * Provider for managing global loading state
 * Uses a counter to handle multiple concurrent loading operations
 */
export const LoadingProvider: FC<PropsWithChildren> = observer(({ children }) => {
  const [isLoading, setIsLoading] = useState(0);

  const showLoading = useCallback(() => {
    setIsLoading((prev) => prev + 1);
  }, []);

  const hideLoading = useCallback(() => {
    setIsLoading((prev) => Math.max(prev - 1, 0));
  }, []);

  const value: LoadingContextValue = useMemo(
    () => ({
      isLoading,
      showLoading,
      hideLoading,
    }),
    [isLoading, showLoading, hideLoading],
  );

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
});

LoadingProvider.displayName = 'LoadingProvider';
